import deputyByRolesReducer from "./deputyByRolesReducer";

const deputyByRolesReducers = {
    deputyByRoles: deputyByRolesReducer,
}

export default deputyByRolesReducers;